import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { initialPhysicalDefaultCommissionState, IPhysicalDefaultCommission } from "./PhysicalDefaultCommission.types";
import { IDataTableV2DateState } from "../../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";


export const FETCH_PHYSICAL_DEFAULT_COMMISSION_LIST_PROGRESS =
  "FETCH_PHYSICAL_DEFAULT_COMMISSION_LIST_PROGRESS";
export const FETCH_PHYSICAL_DEFAULT_COMMISSION_LIST_SUCCESS =
  "FETCH_PHYSICAL_DEFAULT_COMMISSION_LIST_SUCCESS";
export const FETCH_PHYSICAL_DEFAULT_COMMISSION_LIST_FAILURE =
  "FETCH_PHYSICAL_DEFAULT_COMMISSION_LIST_FAILURE";

export const fetchPhysicalDefaultCommissionListProgress = () =>
  action(FETCH_PHYSICAL_DEFAULT_COMMISSION_LIST_PROGRESS);

export const fetchPhysicalDefaultCommissionListSuccess = (data: IPhysicalDefaultCommission[]) =>
  action(FETCH_PHYSICAL_DEFAULT_COMMISSION_LIST_SUCCESS, { data });

export const fetchPhysicalDefaultCommissionListFailed = (errorMessage: string) =>
  action(FETCH_PHYSICAL_DEFAULT_COMMISSION_LIST_FAILURE, { errorMessage });

export const fetchPhysicalDefaultCommissionListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchPhysicalDefaultCommissionListProgress());

      let finalUrl = `/accounting/get-accn-default-invoice-commission?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl = `/accounting/get-accn-default-invoice-commission?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      const res = await api.get(finalUrl);
      const data: IPhysicalDefaultCommission[] = res.data.data;
      dispatch(fetchPhysicalDefaultCommissionListSuccess(data));
    } catch (err: any) {
      dispatch(fetchPhysicalDefaultCommissionListFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };



export const FETCH_PHYSICAL_DEFAULT_COMMISSION_FAILURE = "FETCH_PHYSICAL_DEFAULT_COMMISSION_FAILURE";
export const FETCH_PHYSICAL_DEFAULT_COMMISSION_PROGRESS = "FETCH_PHYSICAL_DEFAULT_COMMISSION_PROGRESS";
export const FETCH_PHYSICAL_DEFAULT_COMMISSION_SUCCESS = "FETCH_PHYSICAL_DEFAULT_COMMISSION_SUCCESS";

export const fetchPhysicalDefaultCommissionProgress = () =>
  action(FETCH_PHYSICAL_DEFAULT_COMMISSION_PROGRESS);
export const fetchPhysicalDefaultCommissionSuccess = (data: IPhysicalDefaultCommission) =>
  action(FETCH_PHYSICAL_DEFAULT_COMMISSION_SUCCESS, { data });
export const fetchPhysicalDefaultCommissionFailure = (errorMessage: string) =>
  action(FETCH_PHYSICAL_DEFAULT_COMMISSION_FAILURE, { errorMessage });

export const fetchPhysicalDefaultCommissionAsync =
  (): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchPhysicalDefaultCommissionProgress());

      const res = await api.get(`/accounting/get-accn-default-invoice-commission`);
      const data = res.data.data;
      if (data.length > 0) {
        dispatch(fetchPhysicalDefaultCommissionSuccess(data[0]));
      } else {
        dispatch(fetchPhysicalDefaultCommissionSuccess(initialPhysicalDefaultCommissionState["data"]));
      }
    } catch (err: any) {
      dispatch(fetchPhysicalDefaultCommissionFailure("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addPhysicalDefaultCommissionAsync =
  (
    data: IPhysicalDefaultCommission,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post("/accounting/edit-accn-default-invoice-commission", {
        ...data,
      });
      const message = "Physical Default Commission saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_PHYSICAL_DEFAULT_COMMISSION = "CLEAR_PHYSICAL_DEFAULT_COMMISSION";
export const clearPhysicalDefaultCommission = () => action(CLEAR_PHYSICAL_DEFAULT_COMMISSION);
